const fetchNew = {
  totalPoints: 'Tổng số điểm',
  ranking: 'Xếp hạng',
  playNow: 'Play Now',
  getListRankingFail: 'Tải danh sách xếp hạng thất bại!',
  previewFetchNews: "Xem trước Fetch News"
}

export default fetchNew
